import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEvent } from '../../../models/index';
import { GetEventState } from '../../actions/types/events/FetchEventDetailTypes';

/**
 * Initial Event state in store
 */
const initialState: GetEventState = {
  isLoading: false,
  eventErrorMessage: '',
  eventDetails: [
    {
      uuid: '',
      status: '',
      version: '0',
      createdBy: '',
      dataEncryption: false,
      createdTimestamp: '',
      updatedBy: '',
      updatedTimestamp: '',
      eventName: '',
      eventDescription: '',
      eventType: '',
      eventCategory: '',
      schema: '',
      eventStatusHistory: [],
      sensitiveFields: [],
      eventSchemaId: '',
      eventSchemaVersion: '1'
    }
  ]
};

const createEventNameSlice = createSlice({
  name: 'fetchEventName',
  initialState,
  reducers: {
    fetchEventNameStarted: (state) => {
      state.isLoading = true;
    },

    fetchEventNameSuccess: (state, action: PayloadAction<IEvent[]>) => {
      state.isLoading = false;
      state.eventDetails = action.payload;
      state.eventErrorMessage = '';
    },

    fetchEventNameFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.eventDetails = initialState.eventDetails;
      state.eventErrorMessage = action.payload;
    },

    clearEventDetails: (state) => {
      state.isLoading = false;
      state.eventDetails = initialState.eventDetails;
      state.eventErrorMessage = '';
    }
  }
});
export const {
  fetchEventNameStarted,
  fetchEventNameSuccess,
  fetchEventNameFail,
  clearEventDetails
} = createEventNameSlice.actions;
export default createEventNameSlice.reducer;
